export default __webpack_public_path__ + "static/media/supportChatDownIcon.94197988.svg";